import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPipeMillReports,
  fetchPipeMillMockData,
  fetchPipeMillReportMetadata,
  savePipeMillReport,
  saveBulkPipeMillReports,
  savePipeMillReportItem,
  savePipeMillReportStatus,
  deletePipeMillReport,
  deletePipeMillReportItem,
  evaluatePipeMillReport,
  fetchPipeMillProjectLimits,
  savePipeMillProjectLimit,
  deletePipeMillProjectLimit,
  fetchPipeMillFrequencyRules,
  savePipeMillFrequencyRule,
  deletePipeMillFrequencyRule,
  fetchPipeMillClearanceStatus,
  clearPipeMillReportSaveStatus,
  clearPipeMillReportErrors,
} from '../actions';

export const usePipeMillReport = () => {
  const dispatch = useDispatch();
  const pipeMillReport = useSelector((state) => state.pipeMillReport);

  return {
    ...pipeMillReport,
    fetchReports: (payload) => dispatch(fetchPipeMillReports(payload)),
    fetchMockData: (payload) => dispatch(fetchPipeMillMockData(payload)),
    fetchMetadata: (payload) => dispatch(fetchPipeMillReportMetadata(payload)),
    saveReport: (payload) => dispatch(savePipeMillReport(payload)),
    saveBulkReports: (payload) => dispatch(saveBulkPipeMillReports(payload)),
    saveReportItem: (payload) => dispatch(savePipeMillReportItem(payload)),
    saveReportStatus: (payload) => dispatch(savePipeMillReportStatus(payload)),
    deleteReport: (payload) => dispatch(deletePipeMillReport(payload)),
    deleteReportItem: (payload) => dispatch(deletePipeMillReportItem(payload)),
    evaluateReport: (payload) => dispatch(evaluatePipeMillReport(payload)),
    fetchProjectLimits: (payload) => dispatch(fetchPipeMillProjectLimits(payload)),
    saveProjectLimit: (payload) => dispatch(savePipeMillProjectLimit(payload)),
    deleteProjectLimit: (payload) => dispatch(deletePipeMillProjectLimit(payload)),
    fetchFrequencyRules: (payload) => dispatch(fetchPipeMillFrequencyRules(payload)),
    saveFrequencyRule: (payload) => dispatch(savePipeMillFrequencyRule(payload)),
    deleteFrequencyRule: (payload) => dispatch(deletePipeMillFrequencyRule(payload)),
    fetchClearanceStatus: (payload) => dispatch(fetchPipeMillClearanceStatus(payload)),
    clearSaveStatus: () => dispatch(clearPipeMillReportSaveStatus()),
    clearErrors: () => dispatch(clearPipeMillReportErrors()),
  };
};
